import buildMeta from '../utils/buildMeta'

const routes = [
  {
    name: 'tracker',
    path: '/tracker',
    component: () => import('@/pages/Tracker/Home.vue'),
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      title: 'Job Tracker - Jobscan',
      description: 'Track your job applications.',
    }),
    children: [
      {
        name: 'tracker-upload',
        path: 'scan/:opportunityId?',
        component: () => import('@/pages/Tracker/components/Uploader.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
        }),
      },
      {
        name: 'tracker-opportunity',
        path: ':opportunityId',
        component: () => import('@/pages/Tracker/components/Opportunity.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
        }),
        children: [
          {
            name: 'opportunity-description',
            path: 'description',
            component: () =>
              import('@/pages/Tracker/components/Description.vue'),
            meta: buildMeta({
              authRequired: true,
              robots: 'noindex',
            }),
          },
          {
            name: 'opportunity-resume',
            path: 'resume',
            component: () => import('@/pages/Tracker/components/Resume.vue'),
            meta: buildMeta({
              authRequired: true,
              robots: 'noindex',
            }),
          },
          {
            name: 'opportunity-interviews',
            path: 'interviews',
            component: () =>
              import('@/pages/Tracker/components/Interviews.vue'),
            meta: buildMeta({
              authRequired: true,
              robots: 'noindex',
            }),
          },
          {
            name: 'opportunity-contacts',
            path: 'contacts',
            component: () => import('@/pages/Tracker/components/Contacts.vue'),
            meta: buildMeta({
              authRequired: true,
              robots: 'noindex',
            }),
          },
          {
            name: 'opportunity-notes',
            path: 'notes',
            component: () => import('@/pages/Tracker/components/Notes.vue'),
            meta: buildMeta({
              authRequired: true,
              robots: 'noindex',
            }),
          },
          {
            name: 'opportunity-coverletter',
            path: 'coverletter',
            component: () => import('@/pages/Tracker/components/CoverLetter.vue'),
            meta: buildMeta({
              authRequired: true,
              robots: 'noindex',
            }),
          },
        ],
      },
    ],
  },
  {
    name: 'chrome-extension',
    path: '/chrome-extension',
    component: () => import('@/pages/Tracker/ChromeExtension.vue'),
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      title: 'Chrome Extension - Jobscan',
      description: 'Enhance your job search.',
    }),
  },
]

export default routes
